import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import './editor.css';
import clsx from 'clsx';
import ImageSelector from '../ImageSelector';
import Cam from '../Cam';
import { Button } from "react-bootstrap";
import LightTooltip from './styles.js';
import api from '../../services/api';
import { isMobile } from 'react-device-detect'
import _, { orderBy, set, cloneDeep } from 'lodash';


let uploadingControl = false;
let doubleClickControl = false;
const handlerSize = isMobile ? 36 : 18;

const Editor = ({ standard, handleChange, idx, standardType }, ref) => {

  useImperativeHandle(ref, () => ({ handleSelectTemplate }));
  const svgRef = React.createRef();
  const svgDiv = React.createRef();
  const mediatoken = localStorage.getItem('mediatoken');

    const [state, setState] = useState({ newObject: null, editObject: [], dragStart: null, objects: [] });
    const [templateObjects, setTemplateObjects] = useState([]);
  const [selected, setSelected] = useState(null);
  const [dragStart, setDragStart] = useState(null);
  const [tool, setTool] = useState('sel');
  const [Ponteiro, setPonteiro] = useState("initial");
  const [svgObjId] = useState('svgObj'+idx);
  const [stepName, setStepName] = useState(standard.steps[idx].name);
  const [key, setKey] = useState(null)
  const [shift, setShift] = useState(false)
  const [ctrl, setCtrl] = useState(false)
  const [copied, setCopied] = useState([])
  const [pasted, setPasted] = useState(false)
  const [color, setColor] = useState(null)
  const [currentColor, setCurrentColor] = useState("black")
    const [mouseDownObj, setMouseDownObj] = useState(null)
    const [uploadImgBackground, setUploadImgBackground] = useState({id: 0, blob: ''})

  const upHandler = ({ key }) => {
    setKey(null)
    if (key === 'Control') setCtrl(false)
    if (key === 'Shift') setShift(false)
  };

  const downHandler = ({ key }) => {
    setKey(key)
    if (key === 'Control') setCtrl(true)
    if (!shift && key === 'Shift') setShift(true)
  };

  useEffect(() => {
    updState();
    /*window.addEventListener("keyup", upHandler);
    window.addEventListener("keydown", downHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener("keyup", upHandler);
      window.removeEventListener("keydown", downHandler);
    };*/
  },[]);


  const ctrlC = () => {
    const newId = Date.now();
    const newObjs = state.objects.filter( obj =>
      state.editObject.includes(obj.id)
    ).map( (obj, idx) => {return {
      ...obj, 
      id: newId + idx, 
      xStart: obj.xStart+10, 
      xEnd: obj.xEnd + 10, 
      yStart: obj.yStart+10, 
      yEnd: obj.yEnd + 10,
    }})
    setCopied(newObjs)
      setTool('sel')
      console.log('newObjs', newObjs);
      if (newObjs.length == 1 && newObjs[0].type == "text") {
          copyToClipboard(newObjs[0].text)
      }
      else {
          copyToClipboard(JSON.stringify(newObjs))
      }
    }

    async function copyToClipboard(content) {
        try {
            await navigator.clipboard.writeText(content);
            console.log('Copied to clipboard');
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }

    async function getFirstClipboardContents() {
        try {
            const clipboardItems = await navigator.clipboard.read();
            console.log(clipboardItems);
            
            if (clipboardItems.length > 0 && clipboardItems[0].types.length > 0) {

                if (clipboardItems[0].types[0] == 'text/plain') {
                    const clip = await navigator.clipboard.readText();
                    return {
                        type: 'text/plain',
                        text: clip
                    }
                }

                const imageIndex = clipboardItems[0].types.findIndex(item => item.startsWith('image/'));
                if (imageIndex > -1) {

                    const blob = await clipboardItems[0].getType(clipboardItems[0].types[imageIndex]);                    
                    return {
                        type: 'image',
                        blob: blob
                    }
                }                
                return null;                
            }
            else
                return null;
        } catch (err) {
            console.error(err.name, err.message);
        }
    }

    const clamp = (a, min = 0, max = 1) => //Math.min(max, Math.max(min, a));
    {
        if (a < min)
            return min;
        if (a > max)
            return max;
        return a;
    }

    const invlerp = (x, y, a) => clamp((a - x) / (y - x));
    function lerp (value1, value2, amount) {
        amount = amount < 0 ? 0 : amount;
        amount = amount > 1 ? 1 : amount;
        return value1 + (value2 - value1) * amount;
    }

    const ctrlV = async () => {
        if (uploadImgBackground.id > 0)
            return;

        uploadingControl = false;

        var clipBoard = copied;
        if (clipBoard.length == 0) {
            const content = await getFirstClipboardContents();
            if (content == null) {
                setTool('sel')
                return;
            }
            if (content.type == 'text/plain') {

                const checkIfIsJson = hasJsonStructure(content.text)

                if (checkIfIsJson && content.text.includes('type')
                    && content.text.includes('"xStart"')
                    && content.text.includes('"yStart"')
                    && content.text.includes('"xEnd"')
                    && content.text.includes('"yEnd"')
                    && content.text.includes('"width"')
                    && content.text.includes('"height"')
                    ) {
                    clipBoard = JSON.parse(content.text);
                    console.log('pasting json',clipBoard);
                }
                else {
                    const sizeAdjuster = lerp(1, 6, invlerp(20, 500, content.text.length));
                    clipBoard.push({
                        id: Date.now(),
                        type: "text",
                        bg: currentColor,
                        xStart: 250,
                        yStart: 250,
                        xEnd: 250,
                        yEnd: 250,
                        width: 100 * sizeAdjuster,
                        height: 100 * sizeAdjuster,
                        fontSize: 18,
                        fontWeight: 'bold',
                        text: content.text,
                    });
                }
            }
            if (content.type == 'image') {
                clipBoard.push({
                    id: Date.now(),
                    type: "img",
                    src: '/media/svg/icons/General/Update.svg',
                    bg: "rgb(50,50,50)",
                    xStart: 250,
                    yStart: 250,
                    xEnd: 250,
                    yEnd: 250,
                    width: 200,
                    height: 200,
                    uploading: false
                });
                setUploadImgBackground({ id: clipBoard[0].id, blob: content.blob });
            }           
            setCopied(clipBoard);
        }

        setState({
          ...state,
            objects: [...state.objects, ...clipBoard]
        })
        setPasted(true)      
        setTool('sel')
  }

    function hasJsonStructure(str) {
        if (typeof str !== 'string') return false;
        try {
            const result = JSON.parse(str);
            const type = Object.prototype.toString.call(result);
            return type === '[object Object]'
                || type === '[object Array]';
        } catch (err) {
            return false;
        }
    }

  const orderUp = () => {
    if (state.editObject.length > 0) {
      let array = state.objects;
      const index = array.findIndex(o => o.id === state.editObject[0]);
      if (index < array.length - 1) {
        const tmp = array[index + 1]
        array[index + 1] = array[index]
        array[index] = tmp
      }
    }
    setTool('sel')
  }

  const orderDown = () => {
    if (state.editObject.length > 0) {
      let array = state.objects;
      const index = array.findIndex(o => o.id === state.editObject[0]);
      if (index >= 1) {
        const tmp = array[index - 1]
        array[index - 1] = array[index]
        array[index] = tmp
      }
    }
    setTool('sel')
  }

  useEffect( () => {
    if ( (tool !== 'edit') && (key === 'Delete' || key === 'Backspace')) {
      let array = state.objects;
      state.editObject.forEach(obj => {
        const index = array.findIndex(o => o.id === obj);
        if (index > -1) {
          array.splice(index, 1);
        }
      })
      setTool('sel');
      setState({ ...state, objects: array, editObject: [] });
    }
      if (ctrl && key && ((standard.lastStepEdited == idx) || (standard.lastStepEdited == undefined && idx == 0))) {
      if (key.toUpperCase() === 'C') {
          ctrlC()
      }
      if (key.toUpperCase() === 'V' && tool !== 'edit') {
          ctrlV()
          //console.log('lastStepEdited', standard.lastStepEdited)
      }
    }
  },[key])

  useEffect( () => {
    const selCopied = copied.map(obj => {return(obj.id)})
    if (pasted) {
      setState({
        ...state,
        editObject: selCopied
      })
        setPasted(false)
        updStandard();
    } 
      setCopied([])
  }, [pasted])

    const imageDimensions = file =>
        new Promise((resolve, reject) => {
            const img = new Image()

            // the following handler will fire after the successful loading of the image
            img.onload = () => {
                const { naturalWidth: width, naturalHeight: height } = img
                resolve({ width, height })
            }

            // and this handler will fire if there was an error with the image (like if it's not really an image or a corrupted one)
            img.onerror = () => {
                reject('There was some problem with the image.')
            }
            console.log('file', file);
            img.src = file;//URL.createObjectURL(file)
        })
    
    useEffect(() => {

        const updatePasteImg = async () => {
            if (uploadImgBackground.id == 0 || uploadingControl)
                return;

            const index = state.objects.findIndex(obj => obj.id == uploadImgBackground.id);
            console.log('index', index, state.objects, uploadImgBackground.id)
            if (index == -1)
                return;

            uploadingControl = true;

            const img = 'standard-' + uploadImgBackground.id + ".png";
            var file = new File([uploadImgBackground.blob], img, { type: 'image/png' });

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: function (progressEvent) {
                    let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    //setProgressNumber(percentCompleted);
                }
            }

            var formData = new FormData();
            formData.append(file.name.toLowerCase(), file);
            let response;
            try {
                response = await api.post('standard/uploadFiles', formData, config);
            }
            catch (error) {
                console.log(error);
                setUploadImgBackground({ id: 0, blob: '' })
                return;
            }
                
            var obj = response.data;
            var filePath = obj[Object.keys(obj)[0]];

            const dimensions = await imageDimensions(addToken(filePath))
            console.log('Dimensions original', dimensions);
            let { width, height } = dimensions;
                    
            const d = (width > height) ? width : height;
            const sc = 300 / d;
            width = sc * width;
            height = sc * height;
            console.log('Dimensions', width, height, d);

            if (isNaN(width)) width = 100;
            if (isNaN(height)) height = 100;

            const uploadedObj = {
                ...state.objects[index],
                uploading: true,
                src: filePath,
                width: clamp(width, 100, 500),
                height: clamp(height, 100, 500)
            }

            console.log('uploadedObj', uploadedObj);
            setState({
                ...state,
                objects: [
                    ...state.objects.slice(0, index),
                    uploadedObj,
                    ...state.objects.slice(index + 1)
                ]
            });
            setUploadImgBackground({ id: 0, blob: '' })
        }
        updatePasteImg();

    }, [uploadImgBackground, state.objects])

  useEffect( () => {
    if (color) setCurrentColor(color)
    if (color && state.editObject) {
      let array = state.objects;
      state.editObject.forEach(obj => {
        const index = array.findIndex(o => o.id === obj);
        if (index > -1) {
          array[index].bg = color;
        }
      })
      setState({ ...state, objects: array });
      setColor(null)
    }
  },[color])

  function updState() {
    let objs = standard.steps[idx].objects;
    if (!objs) {
      objs = (isJson(standard.steps[idx].content)) ? JSON.parse(standard.steps[idx].content) : [];
    }
    setState({
      ...state,
      newObject: null, editObject: [], dragStart: null,       
      objects: objs
    })
    setSelected(null);
    setDragStart(null);
  }

  if (stepName !== standard.steps[idx].name) {
    updState(); 
    setStepName(standard.steps[idx].name);
  }

   //ATUALIZA STANDARD DO COMPONENTE NEWSTANDARD A CADA MODIFICAÇÃO
  const updStandard = () => {
    //const svgObj = document.getElementById(svgObjId);
    const nstandard = standard;
    let step = standard.steps[idx];
    step = { ...step, objects: state.objects };
      nstandard.steps[idx] = step;
      nstandard.lastStepEdited = idx
    if (tool !== "drag" || true) { handleChange(nstandard, idx); }
  }

  useEffect(() => {
    if (tool === "text") {
      setPonteiro("text")
    } else if (tool === "edit") {
      setPonteiro("initial")
    } else if (tool === "clear") {
      if (state.editObject.length > 0) {
        let array = state.objects;
        state.editObject.forEach(id => {
          const index = array.findIndex(o => o.id === id);
          if (index > -1) {
            array.splice(index, 1);
          }
        })
        setState({...state, editObject:[]})
        setTool('sel')
      } else {
        setPonteiro("not-allowed")
      }
    } else {
      setPonteiro("cell")
    }
    if (tool === "selectall") {
      console.log('seleciona tudo')
      const arr = state.objects.map(obj => {return obj.id})
      setState({...state, editObject: arr})
      setTool('sel');
      setPonteiro("initial")
    }    
    if (tool === "clearall") {
      // let arr = state.objects;
      // arr.splice(0, arr.length);
      setTool('sel');
      setPonteiro("initial")
    }
    if (tool === "ctrlC") {
      ctrlC()
    }
    if (tool === "ctrlV") {
      ctrlV()
    }
    if (tool === "orderUp") {
      orderUp()
    }
    if (tool === "orderDown") {
      orderDown()
    }
    if (tool === "sel") setPonteiro("initial")
    
  }, [tool])

  function handleChangeText(obj, e) {
      console.log('handleChangeText',parseInt(e.currentTarget.style.width.slice(0, -2)));
    obj.text = e.currentTarget.value;
    //const { width, height } = document.getElementById('t' + obj.id).getBoundingClientRect();
    obj.width = parseInt(e.currentTarget.style.width.slice(0, -2));
    obj.height = parseInt(e.currentTarget.style.height.slice(0, -2));;
    obj.xEnd = obj.xStart + obj.width;
    obj.yEnd = obj.yStart + obj.height;
    const index = state.objects.findIndex(o => o.id === obj.id);
    setState({
      ...state,
      objects: [
        ...state.objects.slice(0, index),
        obj,
        ...state.objects.slice(index + 1)
      ],
      editObject: []
    });
    setTimeout(() => {
        updStandard();
        if (doubleClickControl) {
            doubleClickControl = false;
            console.log('doubleClickControl = false;')
        }
        else {
            console.log('voltando para sel')
            setTool('sel');
        }
    }, 250);
  }

  function handleMouseDownObj(obj, e) {
     //console.log('mouse down obj', e.target.tagName);
      setMouseDownObj(e.target.tagName)
      doubleClickControl = false;
      if (e.detail == 2 && obj.type == 'text') {
          console.log('2 CLICKS em caixa de texto!');
          setTool('edit')
          setState({ ...state, editObject: [obj.id] })
          doubleClickControl = true;
      }
      else {
          selOneObj(obj, e);
          startDrag(e);
      }      
    }

  function handleMouseDown(e) {
    // console.log('mouse down ' + tool);   
    if (tool !== 'edit') {
      createObj(e);
    } else {
      console.log(mouseDownObj)
    }
    setPonteiro("initial");
  }

  function handleMouseUp(e) {
    // console.log('mouse up ');
    selObjs();
    if (tool !== 'text' && tool !== 'edit') { 
      setTool('sel'); 
    } else {

    }
    setMouseDownObj(null)
    setPonteiro("initial");
    updStandard();
  }

  function selOneObj(obj, e) {
    if (tool === "clear") {
      let array = state.objects;
      const index = array.findIndex(o => o.id === obj.id);
      if (index > -1) {
        array.splice(index, 1);
        }
      setTool('sel');
      setState({ ...state, editObject: [] });
    }

    if (tool === 'edit') {
      setState({...state, editObject:[obj.id]})
      //setTool('text')
    }

    if (tool === 'sel') {
      const bbox = (obj.type === "text")
        ? document.getElementById('d' + obj.id).getBoundingClientRect()
        : document.getElementById(svgObjId).getElementById(obj.id).getBBox();

      const { top, left } = (obj.type === "text")
        ? document.getElementById(svgObjId).getBoundingClientRect()
        : { top: 0, left: 0 }
      
      const dleft = (obj.type === "text") ? 200 : 0;
      const { x: xb, y: yb, width, height } = bbox;
      const { x: xs, y: ys } = getCoords(e);
      /*const xo = xb + width - left - dleft;
      const yo = yb + height - top;
      const yf = yb + 0 - top;
      const d = ((xs - xo) ** 2 + (ys - yo) ** 2) ** 0.5;
      const df = ((xs - xo) ** 2 + (ys - yf) ** 2) ** 0.5;
        const scaleLimit = (width / 2 > handlerSize) ? handlerSize : width / 2;
        console.log(bbox, getCoords(e))*/
      //let otool = (d < scaleLimit) ? 'increase' : (df < scaleLimit && obj.type === "text") ? 'font' : 'drag';

        const xR = xb + width - left - 15 - dleft + (isMobile ? 0 : 18);
        const xL = xb - left - 15 - dleft + (isMobile ? 18 * 2 : 18);

        const yU = yb - top - 15 + (isMobile ? 18 * 2 : 18);
        const yD = yb + height - top - 15 + (isMobile ? 0 : 18);

        let otool = 'drag';

        if (obj.type === "arrow") {
            if (xs > xR && ys > yD ||
                xs > xR && ys < yU) {
                const errorThreshold = Math.abs(obj.xEnd - obj.xStart);
                if (errorThreshold < 10) {
                    if (xs > xR && ys > yD) {
                        if (obj.yStart < obj.yEnd)
                            otool = 'increaseHead';
                        else
                            otool = 'increaseTail';
                    }
                    else {
                        if (obj.yStart < obj.yEnd)
                            otool = 'increaseTail';
                        else
                            otool = 'increaseHead';
                    }

                }
                else {
                    if (obj.xStart < obj.xEnd)
                        otool = 'increaseHead';
                    else
                        otool = 'increaseTail';
                }
            }
            else {
                if (xs < xL && ys > yD ||
                    xs < xL && ys < yU) {
                    const errorThreshold = Math.abs(obj.xEnd - obj.xStart);
                    if (errorThreshold < 10) {
                        if (xs < xL && ys > yD) {
                            if (obj.yEnd < obj.yStart)
                                otool = 'increaseTail';
                            else
                                otool = 'increaseHead';
                        }
                        else {
                            if (obj.yEnd < obj.yStart)
                                otool = 'increaseHead';
                            else
                                otool = 'increaseTail';
                        }
                    }
                    else {
                        if (obj.xStart < obj.xEnd)
                            otool = 'increaseTail';
                        else
                            otool = 'increaseHead';
                    }
                }
            }
        }
        else {
            if (xs > xR && ys > yD)
                otool = 'increaseRD';

            if (xs > xR && ys < yU) {
                if (obj.type === "text")
                    otool = 'font';
                else
                    otool = 'increaseRU';
            }

            if (xs < xL && ys > yD)
                otool = 'increaseLD';

            if (xs < xL && ys < yU)
                otool = 'increaseLU';
        }

        

      setTool(otool);
      const editObject = state.editObject;
      if (!editObject.includes(obj.id)) {
        if (!shift) editObject.splice(0, editObject.length); 
        editObject.push(obj.id); 
      } else {
        if (shift) {
            console.log(editObject)
            const idSel = editObject.findIndex(o => o === obj.id);
            console.log(idSel)
            editObject.splice(idSel, 1);
        }
      }
      setState({ ...state, editObject });
    }

  }

  function selObjs() {
    let idsels = state.editObject;
    let array = state.objects;
    const idSel = state.objects.findIndex(o => o.id === 'sel');
    
    if (idSel >= 0) {
      if (tool === 'sel') {
        const osels = state.objects.filter(intersectRect, state.objects[idSel])
        idsels = osels.map(o => { return o.id })
      }
      array.splice(idSel, 1);
    }
    setState({ ...state, objects: array, editObject: idsels, newObject: null });
  }

  function startDrag(e) {
    const dragStart = {
      x: (e.clientX === undefined) ? e.touches[0].clientX : e.clientX,
      y: (e.clientX === undefined) ? e.touches[0].clientY : e.clientY
    }
    setDragStart(dragStart);
  }


  function handleMouseMove(e) {
    if (tool !== 'edit') e.preventDefault();
    const { newObject } = state;
    if (newObject && tool !== 'drag' && !tool.includes('increase') && tool !== 'font' && tool !== 'img') {
      const index = state.objects.findIndex(o => o.id === newObject);
      const { x: xEnd, y: yEnd } = getCoords(e);
      const obj = {
        ...state.objects[index],
        xEnd,
        yEnd,
      };
      //console.log(tool);
      setState({
        ...state,
        objects: [
          ...state.objects.slice(0, index),
          obj,
          ...state.objects.slice(index + 1)
        ]
      });
    }

    if ((tool === 'drag' || tool.includes('increase') || tool === 'font') && dragStart) {
      const { x: xDragStart, y: yDragStart } = dragStart;

      const xDragEnd = (e.clientX === undefined) ? e.touches[0].clientX : e.clientX;
      const yDragEnd = (e.clientY === undefined) ? e.touches[0].clientY : e.clientY;

      let objs = state.objects;
      state.editObject.map((eobj) => {

        const index = objs.findIndex(o => o.id === eobj);
        let obj = objs[index];

        let fontDelta, xStartDelta, yStartDelta, xEndDelta, yEndDelta, widthDelta, heightDelta;
        xStartDelta = 0;
        yStartDelta = 0;
        xEndDelta = 0;
        yEndDelta = 0;
        widthDelta = 0;
        heightDelta = 0;
        fontDelta = 0;
        if (tool === 'drag') {
          xStartDelta = xDragEnd - xDragStart;
          yStartDelta = yDragEnd - yDragStart;
          xEndDelta = xStartDelta;
          yEndDelta = yStartDelta;

          }

          if (tool === "increaseHead") {
              xEndDelta = xDragEnd - xDragStart;
              yEndDelta = yDragEnd - yDragStart;
          }

          if (tool === "increaseTail") {
              xStartDelta = xDragEnd - xDragStart;
              yStartDelta = yDragEnd - yDragStart;
          }

        if (tool === "increaseRD") {
          if (obj.type === 'rect' || obj.type === 'circ') {
            xEndDelta = xDragEnd - xDragStart;
            yEndDelta = yDragEnd - yDragStart;
          }
            if (obj.type === 'text' || obj.type === 'img') {
            widthDelta = xDragEnd - xDragStart;
            heightDelta = yDragEnd - yDragStart;
            }
          }

          if (tool === "increaseRU") {
              if (obj.type === 'rect' || obj.type === 'circ') {
                  xEndDelta = xDragEnd - xDragStart;
                  yStartDelta = yDragEnd - yDragStart;
              }
              if (obj.type === 'text' || obj.type === 'img') {
                  widthDelta = xDragEnd - xDragStart;
                  heightDelta = yDragStart - yDragEnd;
                  yStartDelta = yDragEnd - yDragStart;
              }
              if (obj.type === 'arrow') {
                  xEndDelta = xDragEnd - xDragStart;
                  yEndDelta = yDragEnd - yDragStart;
              }
          }

          if (tool === "increaseLD") {
              if (obj.type === 'rect' || obj.type === 'circ') {
                  xStartDelta = xDragEnd - xDragStart;
                  yEndDelta = yDragEnd - yDragStart;
              }
              if (obj.type === 'text' || obj.type === 'img') {
                  xStartDelta = xDragEnd - xDragStart;
                  widthDelta = xDragStart - xDragEnd;
                  heightDelta = yDragEnd - yDragStart;
              }
              if (obj.type === 'arrow') {
                  xEndDelta = xDragEnd - xDragStart;
                  yEndDelta = yDragEnd - yDragStart;
              }
          }

          if (tool === "increaseLU") {
              if (obj.type === 'rect' || obj.type === 'circ') {
                  xStartDelta = xDragEnd - xDragStart;
                  yStartDelta = yDragEnd - yDragStart;
              }
              if (obj.type === 'text' || obj.type === 'img') {
                  xStartDelta = xDragEnd - xDragStart;
                  widthDelta = xDragStart - xDragEnd;
                  heightDelta = yDragStart - yDragEnd;
                  yStartDelta = yDragEnd - yDragStart;
              }
              if (obj.type === 'arrow') {
                  xEndDelta = xDragEnd - xDragStart;
                  yEndDelta = yDragEnd - yDragStart;
              }
          }
        if (tool === "font" && obj.type === 'text') {
            fontDelta = (yDragEnd - yDragStart) / 4;
          }
          let xStart, xEnd, yStart, yEnd, width, height;
          switch (obj.type) {
              case "arrow":
                  xStart = obj.xStart + xStartDelta
                  xEnd =   obj.xEnd + xEndDelta
                  yStart = obj.yStart + yStartDelta
                  yEnd =   obj.yEnd + yEndDelta
                  width =  obj.width + widthDelta
                  height = obj.height + heightDelta
                  break;
              case 'text':
              case 'img':
                  xStart = clamp(obj.xStart + xStartDelta, -2000, obj.xStart + obj.width - 15);                  
                  yStart = clamp(obj.yStart + yStartDelta, -2000, obj.yStart + obj.height - 15);                  
                  width = clamp(obj.width + widthDelta, 15, 2000);
                  height = clamp(obj.height + heightDelta, 15, 2000);

                  xEnd = xStart + obj.width;
                  yEnd = yStart + obj.height;
                  break;
              default:
                  xStart = clamp(obj.xStart + xStartDelta, -2000, obj.xEnd - 15);
                  xEnd = clamp(obj.xEnd + xEndDelta, obj.xStart + 15, 2000);
                  yStart = clamp(obj.yStart + yStartDelta, -2000, obj.yEnd - 15);
                  yEnd = clamp(obj.yEnd + yEndDelta, obj.yStart + 15, 2000);
                  width = clamp(obj.width + widthDelta, 15, 2000);
                  height = clamp(obj.height + heightDelta, 15, 2000);
                  break;
          }

        

        obj = {
          ...obj,
            xStart: xStart,
            xEnd:   xEnd,
            yStart: yStart,
            yEnd:   yEnd,
            width:  width, 
            height: height,
            fontSize: clamp(obj.fontSize - fontDelta, 8, 500)
          };
          //console.log(obj);
        objs = [...objs.slice(0, index), obj, ...objs.slice(index + 1)]
      });

      setDragStart({
        x: xDragEnd,
        y: yDragEnd
      });

      setState({
        ...state,
        objects: objs
      });

    }
  }

  async function handleSelectImage(img) {
    if (img) {
      setSelected(img);
      setTool("img");
    } else {
      setTool('')
    }
  }

    function createObj(e) {
        
    const { x: xStart, y: yStart } = getCoords(e);
    let index = state.objects.findIndex(o => o.type === 'text');
    if (index < 0) {index = state.objects.length}

    if (tool === "sel") {
      setState(s => {
        const obj = {
          id: 'sel',
          type: "sel",
          bg: "rgb(" + [150, 150, 150] + ")",
          xStart,
          yStart,
          xEnd: xStart,
          yEnd: yStart,
        };
        return {
          ...state,
          objects: [...s.objects, obj],
          newObject: obj.id,
        }
      });
    }

    if (tool === "img" && selected) {
      setTool("sel");
      console.log(selected);
      const image = new Image();
      image.src = addToken(selected);
        let { width, height } = image;
        width = parseInt(width);
        height = parseInt(height);
      const d = (width > height) ? width : height;
      const sc = 300 / d;
      width = sc * width;
        height = sc * height;

      setState(s => {
        const obj = {
          id: Date.now(),
          type: "img",
          src: selected ?? '',
          bg: "rgb(50,50,50)",
          xStart,
          yStart,
          xEnd: xStart,
          yEnd: yStart,
            width: 300,
            height: 300
        };
        return {
          ...state,
          objects: [obj, ...s.objects],
        };
      });
    }

    if (tool === "rect") {
      setState(s => {
        const obj = {
          id: Date.now(),
          type: "rect",
          bg: currentColor,
          xStart,
          yStart,
          xEnd: xStart,
          yEnd: yStart,
        };
        return{
            ...state,
            objects: [
              ...s.objects.slice(0, index),
              obj,
              ...s.objects.slice(index)
            ],
            newObject: obj.id
        }
      });
    }

    if (tool === "arrow") {
      setState(s => {
        const obj = {
          id: Date.now(),
          type: "arrow",
          bg: currentColor,
          xStart,
          yStart,
          xEnd: xStart,
          yEnd: yStart,
        };
        return{
          ...state,
          objects: [
            ...s.objects.slice(0, index),
            obj,
            ...s.objects.slice(index)
          ],
          newObject: obj.id
        }
      });
    }

    if (tool === "circ") {
      setState(s => {
        const obj = {
          id: Date.now(),
          type: "circ",
          bg: currentColor,
          xStart,
          yStart,
          xEnd: xStart,
          yEnd: yStart,
        };
        return{
          ...state,
          objects: [
            ...s.objects.slice(0, index),
            obj,
            ...s.objects.slice(index)
          ],
          newObject: obj.id
        }
      });
    }

    if (tool === "text") {
      //setTool('edit');
      const obj = {
        id: Date.now(),
        type: "text",
        bg: currentColor,
        xStart,
        yStart,
        xEnd: xStart,
        yEnd: yStart,
        width: 100,
        height: 50,
        fontSize: 18,
        fontWeight: 'bold',
        text: 'texto',
      };
      setState({ ...state, objects: [...state.objects, obj] })
      setTool('edit');
      setTimeout(() => {
        if(document.getElementById('t' + obj.id))
            document.getElementById('t' + obj.id).select();
      }, 500);
    }

  }

  //**************RENDERS****************/

  function renderCirc(obj) {
    let x, y, w, he;

    if (obj.xStart < obj.xEnd) {
      x = obj.xStart;
      w = obj.xEnd - obj.xStart;
    } else {
      x = obj.xEnd;
      w = obj.xStart - obj.xEnd;
    }

    if (obj.yStart < obj.yEnd) {
      y = obj.yStart;
      he = obj.yEnd - obj.yStart;
    } else {
      y = obj.yEnd;
      he = obj.yStart - obj.yEnd;
    }

    const r = Math.min(he / 2, w / 2);
    const rx = obj.locked ? r : w / 2;
    const ry = obj.locked ? r : he / 2;
    const bg = ('bg' in obj) ? obj.bg : "black";

    return (
      <g key={obj.id}>
        <ellipse
          id={obj.id}
          cx={x + rx}
          cy={y + ry}
          rx={rx}
          ry={ry}
          stroke={bg}
          cursor="grab"
          strokeWidth={3}
          fill="rgba(0,0,0,0)"
          onMouseDown={handleMouseDownObj.bind(this, obj)}
          onTouchStart={handleMouseDownObj.bind(this, obj)}
        />
        {state.editObject && (state.editObject.includes(obj.id)) && renderBox(this, obj)}
      </g>
    );
  }

  function renderText(obj) {
    const divid = "d" + obj.id;
    const divit = "t" + obj.id;
    // if (!obj.width) {
    //   console.log(obj)
    //   obj.width = obj.xEnd - obj.xStart;
    //   obj.height = obj.yEnd - obj.yStart;
    // }
    const bg = (obj.id >  1634601600000)  ? obj.bg : "black";
    let width=('width' in obj) ? obj.width : obj.xEnd - obj.xStart;
    let height=('height' in obj) ? obj.height : obj.yEnd - obj.yStart;
      if (width <= 10) width = 100;
      if (height <= 10) height = 50;
    const textStyle = 
    // (obj.id > 1634601600000)  ?
        { disable: true, wordWrap: 'break-word', whiteSpace:'pre-wrap', width: obj.width, height: obj.height, display: 'inline-block', color: bg, fontSize: obj.fontSize, fontWeight: obj.fontWeight }
    // :
    // { width: obj.width, height: obj.height, whiteSpace:'pre', fontSize: obj.fontSize, fontWeight: obj.fontWeight, color: 'black' }
    return (
      <g key={'gt' + obj.id}>
        <foreignObject
          id={obj.id}
          x={obj.xStart}
          y={obj.yStart}
          width={width}
          height={height}
          cursor="grab"
                onMouseDown={handleMouseDownObj.bind(this, obj)}
                onTouchStart={handleMouseDownObj.bind(this, obj)}
          style={{ overflow: 'visible'}}
        >
          {/* {(tool === 'edit' && state.editObject.length > 0 && state.editObject.includes(obj.id)) && */}
          {(tool === 'edit') &&  
            <textarea id={divit}
              autoFocus= {(state.editObject.length > 0 && state.editObject.includes(obj.id))}
              wrap="hard"
              style={{ height: height + 0, width: width + 0, resize: 'both', border: 'solid 1px', fontSize: obj.fontSize, fontWeight: obj.fontWeight }}
              onBlur={handleChangeText.bind(this, obj)}
            >
              {obj.text}
            </textarea>
          } 
          {/* {!(tool === 'edit' && state.editObject.length > 0 && state.editObject.includes(obj.id)) && */}
          {(tool !== 'edit') &&
            <div id={divid} style={textStyle}>
              {obj.text}
            </div>
          }
        </foreignObject>

        {state.editObject.length > 0 && ((state.editObject.includes(obj.id)) && tool !== 'edit' && tool !== 'text') && renderBox(this, obj)}
      </g>
    )
  }

  function renderArrow(obj) {
    let d = Math.abs(obj.xStart - obj.xEnd) + Math.abs(obj.yStart - obj.yEnd);
    const bg = ('bg' in obj) ? obj.bg : "black";
    if (d > 10) {
      return (
        <g key={'a' + obj.id} >
          <marker id={"triangle" + obj.id}
            viewBox="0 0 10 10" refX="0" refY="5"
            markerUnits="strokeWidth"
            markerWidth="5" markerHeight="4"
            cursor="grab"
            fill={bg}
            orient="auto">
            <path d="M 0 0 L 10 5 L 0 10 z" />
          </marker>
          <line
            id={obj.id}
            x1={obj.xStart}
            y1={obj.yStart}
            x2={obj.xEnd}
            y2={obj.yEnd}
            stroke={bg}
            cursor="grab"
            strokeWidth="7"
            markerEnd={"url(#triangle" + obj.id + ")"}
            onMouseDown={handleMouseDownObj.bind(this, obj)}
            onTouchStart={handleMouseDownObj.bind(this, obj)}
          />
          {state.editObject && (state.editObject.includes(obj.id)) && renderBox(this, obj)}
        </g>
      )
    }
  }

  function addToken(url) {
    const urlToken = url + '?' + mediatoken;
    return (urlToken)
  }

  function renderImg(obj) {
    return (
      <g key={'i'+obj.id}>
        <image
          preserveAspectRatio="xMinYMin meet"
          id={obj.id}
          x={obj.xStart}
          y={obj.yStart}
          width={obj.width}
          height={obj.height}
          cursor="grab"
          href={addToken(obj.src)} //{localStorage.getItem(obj.src) ?? ''}
          onMouseDown={handleMouseDownObj.bind(this, obj)}
          onTouchStart={handleMouseDownObj.bind(this, obj)}
        />
        {state.editObject && (state.editObject.includes(obj.id)) && renderBox(this, obj)}
      </g>

    )

  }

  function renderRect(obj) {
    let x, y, w, he;

    if (obj.xStart < obj.xEnd) {
      x = obj.xStart;
      w = obj.xEnd - obj.xStart;
    } else {
      x = obj.xEnd;
      w = obj.xStart - obj.xEnd;
    }

    if (obj.yStart < obj.yEnd) {
      y = obj.yStart;
      he = obj.yEnd - obj.yStart;
    } else {
      y = obj.yEnd;
      he = obj.yStart - obj.yEnd;
    }

    const size = Math.min(w, he);
    const bg = ('bg' in obj) ? obj.bg : "black";

    return (
      <g key={obj.id}>
        <rect
          id={obj.id}
          x={x}
          y={y}
          width={obj.locked ? size : w}
          height={obj.locked ? size : he}
          stroke={bg}
          strokeWidth={3}
          cursor="grab"
          fill="rgba(0,0,0,0)"
          onMouseDown={handleMouseDownObj.bind(this, obj)}
          onTouchStart={handleMouseDownObj.bind(this, obj)}
        />
        {state.editObject.length > 0 && (state.editObject.includes(obj.id)) && renderBox(this, obj)}
      </g>
    );
  }

  function renderSel(obj) {
    let x, y, w, he;
    if (obj.xStart < obj.xEnd) {
      x = obj.xStart;
      w = obj.xEnd - obj.xStart;
    } else {
      x = obj.xEnd;
      w = obj.xStart - obj.xEnd;
    }

    if (obj.yStart < obj.yEnd) {
      y = obj.yStart;
      he = obj.yEnd - obj.yStart;
    } else {
      y = obj.yEnd;
      he = obj.yStart - obj.yEnd;
    }
    return <rect
      key={'ksel'}
      id={obj.id}
      x={x}
      y={y}
      width={w}
      height={he}
      strokeWidth={1}
      stroke='grey'
      strokeDasharray="5,5"
      cursor="grab"
      fill="rgba(0,0,0,0)"
      onMouseDown={handleMouseDownObj.bind(this, obj)}
      onTouchStart={handleMouseDownObj.bind(this, obj)}
    />
  }

    function renderBox(othis, obj) {
        let bbox;
        try {
            bbox = (obj.type === "text" && tool !== 'edit' && tool !== 'text' && document.getElementById('d' + obj.id))
                ? document.getElementById('d' + obj.id).getBoundingClientRect()
                : document.getElementById(svgObjId).getElementById(obj.id).getBBox();
        } catch (e) {
            console.log(e)
            return;
        }
    
    // const bbox = document.getElementById(svgObjId).getElementById(obj.id).getBBox();

    const { top, left } = (obj.type === "text")
      ? document.getElementById(svgObjId).getBoundingClientRect()
      : { top: 0, left: 0 }

    const dleft = (obj.type === "text") ? 200 : 0;
    return (
      <>
        <rect
          id='box'
          x={bbox.x - 10 - left - dleft}
          y={bbox.y - 10 - top}
          width={bbox.width + 20}
          height={bbox.height + 20}
          stroke='grey'
          strokeDasharray="5,5"
          fill="rgba(0,0,0,0)"
          onTouchStart={handleMouseDownObj.bind(othis, obj)}
          onMouseDown={handleMouseDownObj.bind(othis, obj)}
        />
        {
            (obj.type === "arrow") ?
                <>
                    <rect
                        id='scaleHead'
                            x={
                                obj.xEnd > obj.xStart ?
                                    bbox.x + bbox.width - left - 15 - dleft + (isMobile ? 0 : 18)
                                    :
                                    bbox.x - left - 15 - dleft
                            }
                            y={
                                obj.yEnd > obj.yStart ?
                                    bbox.y + bbox.height - top - 15 + (isMobile ? 0 : 18)
                                    :
                                    bbox.y - top - 15
                            }
                        width={handlerSize}
                        height={handlerSize}
                        fill="rgba(0,150,0,0.4)"
                        onTouchStart={handleMouseDownObj.bind(othis, obj)}
                        onMouseDown={handleMouseDownObj.bind(othis, obj)}
                    />
                        
                    <rect
                        id='scaleTail'
                            x={
                                obj.xEnd < obj.xStart ?
                                    bbox.x + bbox.width - left - 15 - dleft + (isMobile ? 0 : 18)
                                    :
                                    bbox.x - left - 15 - dleft
                            }
                            y={
                                obj.yEnd < obj.yStart ?
                                    bbox.y + bbox.height - top - 15 + (isMobile ? 0 : 18)
                                    :
                                    bbox.y - top - 15
                            }
                        width={handlerSize}
                        height={handlerSize}
                        fill="rgba(150,0,0,0.4)"
                        onTouchStart={handleMouseDownObj.bind(othis, obj)}
                        onMouseDown={handleMouseDownObj.bind(othis, obj)}
                    />
                </>
                :
          <>
            <rect
              id='scaleRD'
              x={bbox.x + bbox.width - left - 15 - dleft + (isMobile ? 0 : 18)}
              y={bbox.y + bbox.height - top - 15  + (isMobile ? 0 : 18)}
              width={handlerSize}
              height={handlerSize}
              fill="rgba(0,0,0,0.4)"
              onTouchStart={handleMouseDownObj.bind(othis, obj)}
              onMouseDown={handleMouseDownObj.bind(othis, obj)}
                    />

                    <rect
                        id='scaleLD'
                        x={bbox.x - left - 15 - dleft}
                        y={bbox.y + bbox.height - top - 15 + (isMobile ? 0 : 18)}
                        width={handlerSize}
                        height={handlerSize}
                        fill="rgba(0,0,0,0.4)"
                        onTouchStart={handleMouseDownObj.bind(othis, obj)}
                        onMouseDown={handleMouseDownObj.bind(othis, obj)}
                    />
                    <rect
                        id='scaleLU'
                        x={bbox.x - left - 15 - dleft}
                        y={bbox.y - top - 15}
                        width={handlerSize}
                        height={handlerSize}
                        fill="rgba(0,0,0,0.4)"
                        onTouchStart={handleMouseDownObj.bind(othis, obj)}
                        onMouseDown={handleMouseDownObj.bind(othis, obj)}
                    />
            {
                (obj.type === "text") ?
              <>
              <rect
                id='scaleFont'
                x={bbox.x + bbox.width - left - 5 - dleft}
                y={bbox.y + 0 - top - 15}
                width={40}
                height={24}
                fill="white"
                stroke="black"
                onTouchStart={handleMouseDownObj.bind(othis, obj)}
                onMouseDown={handleMouseDownObj.bind(othis, obj)}
              />
              <text
                id='scaleFontText'
                x={bbox.x + bbox.width - left - 2 - dleft}
                y={bbox.y + 0 - top + 2}
                fontSize={"12px"}
                fill="black"
                onTouchStart={handleMouseDownObj.bind(othis, obj)}
                onMouseDown={handleMouseDownObj.bind(othis, obj)}
              >{"Fonte"}</text>
              </>

                :

                <rect
                    id='scaleRD'
                    x={bbox.x + bbox.width - left - 15 - dleft + (isMobile ? 0 : 18)}
                    y={bbox.y - top - 15}
                    width={handlerSize}
                    height={handlerSize}
                    fill="rgba(0,0,0,0.4)"
                    onTouchStart={handleMouseDownObj.bind(othis, obj)}
                    onMouseDown={handleMouseDownObj.bind(othis, obj)}
                />
          }
        </>
        }
      </>
    );
  }

  function editorSize(standardType) {
    switch (standardType.toUpperCase()) {
        case 'IDCARD':
        case 'IDC':
        case 'LPP':
        case 'TEMPLATE':
        return "canvasEditorLPP";
      case 'DTP':
        return "canvasEditorDTP";
      default:
        return "canvasEditor";
    }
  }

  function getSizes(standardType) {
    switch (standardType.toUpperCase()) {
        case 'IDCARD':
        case 'IDC':
        case 'LPP':
        case 'TEMPLATE':
        return {
          width: '650',
          height: '800',
        };
      case 'DTP':
        return {
          width: '650',
          height: '500',
        };
      default:
        return {
          width: '650',
          height: '650',
        };
    }
  }

  function getCoords(e) {
    const { top, left } = svgRef.current.getBoundingClientRect();
    const fth = 1; 

    const clientX = (e.clientX === undefined) ? e.touches[0].clientX : e.clientX;
    const clientY = (e.clientY === undefined) ? e.touches[0].clientY : e.clientY;

    return { x: (clientX - left - 200) * fth, y: (clientY - top) * fth };
  }

  const svgStyle = {
    touchAction: (tool !== 'drag') ? 'none' : 'none',
    }

  return (
    <div className={editorSize(standardType)} ref={svgDiv} >
          {/*<span>{tool}</span>*/}
      <div className='d-flex justify-content-between align-items-end' style={{maxWidth:'680px'}}>
        <div className="btn-toolbar" role="toolbar" aria-label="...">
          <div className="btn-group mr-2 bg-white" role="group" aria-label="...">
            {[["arrow", "Seta", 'fas fa-long-arrow-alt-right'], ["rect", "Retângulo", 'far fa-square'], ["circ", "Círculo", 'far fa-circle'], ['text', 'Texto', 'fas fa-font']].map(t => (
              <LightTooltip title={t[1]} >
                <button type="button" className={{ active: tool === t[0] }, classNames(" btn btn-outline-secondary btn-icon")}
                  key={t[0]}
                  onClick={setTool.bind(this, t[0])}>
                  <i className={clsx('icon', t[2])}></i>
                </button>
              </LightTooltip>
            ))}
            <LightTooltip title='Câmera' >
              <span><ImageSelector withImageBank={false} withSimpleUpload={true} standard={standard} handleChange={handleChange} idx={idx} handleSelectImage={handleSelectImage} iconSelect="Camera" accept="image/*" /></span>
            </LightTooltip>
            <LightTooltip title='Imagem' >
              <span><ImageSelector withImageBank={true} withSimpleUpload={false} standard={standard} handleChange={handleChange} idx={idx} handleSelectImage={handleSelectImage} iconSelect="" accept="image/*" /></span>
            </LightTooltip>
          </div>
        </div>

        <div className="btn-toolbar" role="toolbar" aria-label="..." >
          <div className="btn-group mr-2 bg-white" role="group" aria-label="...">
            {[
              ["edit", 'Editar Texto', 'fas fa-edit edit-text'], 
              ["orderUp", "para frente", 'fas fa-level-up-alt'], 
              ["orderDown", "para trás", 'fas fa-level-down-alt'], 
              ["clear", "Remover", 'fas fa-trash'],
              ["selectall", "Selecionar Tudo", 'fas fa-object-group'],
              ["ctrlC", "Copiar", 'far fa-copy'],
              ["ctrlV", "Colar", 'fas fa-paste'],
            ].map(t => (
              <LightTooltip title={t[1] == 'Colar' && uploadImgBackground.id > 0 ? 'Aguarde o encerramento do processo de colar da imagem.' : t[1]} >
                <button type="button" className={classNames({ active: tool === t[0] }, " btn btn-outline-secondary btn-icon")}
                  key={t[0]}
                  style={{ backgroundColor: t[1] == 'Copiar' && copied.length != 0 ? '#78e870' : ''}}
                        disabled={t[1] == 'Colar' && uploadImgBackground.id > 0}
                  onClick={setTool.bind(this, t[0])}
                        >
                  {t[2] ? <i className={clsx('icon', t[2])}></i> : t[1]}
                </button>
              </LightTooltip>
            ))}
          </div>
        </div>
        
        
          <div className="m-1 bg-white d-flex flex-fill flex-wrap" aria-label="..." style={{maxWidth:'280px'}}>
            {[
              ['black'],
              ['gray'],
              ['lightGrey'],
              ['darkRed'],
              ['rgb(210, 0, 0)'],
              ['lightCoral'],              
              ['rgb(0, 102, 204)'],
              ['lightSkyBlue'],
              ['darkOrange'],
              ['gold'],
              ['green'],
              ['lightGreen'],
            ].map(t => (
                <button 
                  type="button" 
                  className={classNames("btn")}
                  style={{
                    minHeight:'30px',
                    backgroundColor: t[0], 
                    border: currentColor === t[0] ? "1px solid white" : "1px solid grey"
                  }}
                  key={t[0]}
                  onClick={setColor.bind(this, t[0])}>
                </button>
            ))}
          </div>

      </div>

      <svg
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onTouchStart={handleMouseDown}
        onTouchEnd={handleMouseUp}
        onMouseMove={handleMouseMove}
        onTouchMove={handleMouseMove}
        ref={svgRef}
        style={svgStyle}
        cursor={Ponteiro}
        id={svgObjId}
        viewBox={"0 0 " + getSizes(standardType).width + " " + getSizes(standardType).height}
      >
        <rect x="0" y="0" width={getSizes(standardType).width} height={getSizes(standardType).height} fill="rgba(0,0,0,0)" stroke="gray" />
        {state.objects && state.objects.map(o => {
          if (o.type === "rect") {
            return renderRect(o);
          }

          if (o.type === "sel") {
            return renderSel(o);
          }

          if (o.type === "circ") {
            return renderCirc(o);
          }

          if (o.type === "text") {
            return renderText(o);
          }

          if (o.type === "img") {
            return renderImg(o);
          }

          if (o.type === "arrow") {
            return renderArrow(o);
          }

          return null;
        })}
      </svg>


    </div>
  );


    function handleSelectTemplate(objs) {
       
        var newObjs = _.cloneDeep(objs);
        state.objects.forEach( o => 
        {
            var findTemplateObjectsInCurrentEditor = templateObjects.find(to => to.id == o.id);
            if (findTemplateObjectsInCurrentEditor == null) {
                newObjs.push(o);
            }
        })

        setTemplateObjects(objs)
        setState({ ...state, objects: newObjs })
    }

}

export default forwardRef(Editor);

//**** AUXILIAR FUNCTIONS *****//

function intersectRect(r1) {
  const r2 = this;
  let { xStart, xEnd, yStart, yEnd } = r1;
  if (xEnd < xStart) { xEnd = [xStart, xStart = xEnd][0] }
  if (yEnd < yStart) { yEnd = [yStart, yStart = yEnd][0] }

  if (r2.xEnd < r2.xStart) { r2.xEnd = [r2.xStart, r2.xStart = r2.xEnd][0] }
  if (r2.yEnd < r2.yStart) { r2.yEnd = [r2.yStart, r2.yStart = r2.yEnd][0] }
  return !(r1.id === 'sel' ||
    r2.xStart > xEnd ||
    r2.xEnd < xStart ||
    r2.yStart > yEnd ||
    r2.yEnd < yStart);
}

var hasOwn = {}.hasOwnProperty;
function classNames() {
  var classes = [];
  for (var i = 0; i < arguments.length; i++) {
    var arg = arguments[i];
    if (!arg) continue;
    var argType = typeof arg;
    if (argType === 'string' || argType === 'number') {
      classes.push(arg);
    } else if (Array.isArray(arg)) {
      classes.push(classNames.apply(null, arg));
    } else if (argType === 'object') {
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes.push(key);
        }
      }
    }
  }
  return classes.join(' ');
}

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
